import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'dynamicLocalizedDate',
  pure: false,
  standalone: true,
})
export class DynamicLocalizedDatePipe implements PipeTransform {
  transform(value: any, format = 'L'): string {
    return moment(value).locale(moment.locale()).format(format);
  }
}
